module.exports = __webpack_public_path__ + "img/main.md.691ca73b.webp";